<template>
    <v-container
        fluid
        class="px-4"
        v-if="customer">
        <v-row>
            <v-col cols="4">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('customerList.customerDetails.lastestLoginDate')"/>
                <div class="body-2">
                    <span class="pr-1">{{ $util.getDDMMYYYYDateFormat(customer.latestLoginDate) }}</span>
                    <span class="grey--text">{{ $util.getHHSSDateFormat(customer.latestLoginDate) }}</span>
                </div>
            </v-col>
            <v-col cols="4">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('customerList.customerDetails.registerDate')"/>
                <div class="body-2">
                    <span class="pr-1">{{ $util.getDDMMYYYYDateFormat(customer.createdAt) }}</span>
                    <span class="grey--text">{{ $util.getHHSSDateFormat(customer.createdAt) }}</span>
                </div>
            </v-col>
            <v-col cols="4">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('customerList.customerDetails.registerBy')"/>
                <div class="body-2">
                    {{ getCustomerRegisterTypeById(customer.id) }}
                </div>
            </v-col>

            <hr class="full-width ma-4">

            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('customerList.customerDetails.customerId')"/>
                <v-text-field
                    outlined
                    disabled
                    hide-details
                    height="40px"
                    v-model="customer.CustomerID"/>
            </v-col>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('customerList.customerDetails.email')"/>
                <v-text-field
                    outlined
                    disabled
                    hide-details
                    height="40px"
                    v-model="customer.email"/>
            </v-col>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('customerList.customerDetails.firstName')"/>
                <v-text-field
                    outlined
                    hide-details
                    height="40px"
                    v-model="customer.name"/>
            </v-col>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('customerList.customerDetails.lastName')"/>
                <v-text-field
                    outlined
                    hide-details
                    height="40px"
                    v-model="customer.lastname"/>
            </v-col>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('customerList.customerDetails.nationality')"/>
                <v-select
                    outlined
                    hide-details
                    v-model="customer.nationality"
                    append-icon="expand_more"
                    height="40px"
                    :menu-props="{
                        offsetY: true
                    }"
                    :items="nationalities"/>
            </v-col>

            <hr class="full-width ma-4">

            <v-col cols="12">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('bookingList.bookingHistory')"/>
                <booking-table
                    disable-sort
                    :items="customer.bookingList"
                    :excludeHeaders="[
                        $constant.table.BOOKING_HEADER_KEY.firstName,
                        $constant.table.BOOKING_HEADER_KEY.lastName,
                        $constant.table.BOOKING_HEADER_KEY.quantity,
                        $constant.table.BOOKING_HEADER_KEY.amount,
                        $constant.table.BOOKING_HEADER_KEY.saleAccount
                    ]"
                    :options="{
                        sortBy: ['bookingDate'],
                        sortType: [true]
                    }"
                    @viewDetails="viewBookingDetails"/>
            </v-col>
        </v-row>
        <right-panel
            hideBottom
            ref="bookingDetailsPanel"
            :title="$t('bookingList.bookingDetails.header')">
            <template v-slot:content="{ context }" >
                <booking-details-view
                    :booking="context"
                    :productTableExcludeHeaders="[
                        'description',
                        'productType',
                        'status',
                        'total',
                        'amount'
                    ]"/>
            </template>
        </right-panel>
    </v-container>
    <div v-else></div>
</template>

<script>
import RightPanel from '@/components/panels/RightPanel'
import BookingDetailsView from '@/views/BookingDetailsView'
import BookingTable from '@/components/tables/BookingTable'

import { mapState, mapGetters } from 'vuex'

export default {
    name: 'CustomerDetailsView',

    components: {
        RightPanel,
        BookingTable,
        BookingDetailsView
    },

    props: {
        customer: {
            type: Object,
            default: null
        }
    },

    data () {
        return {
            statusList: [
                this.$constant.ACTIVE_STATUS,
                this.$constant.INACTIVE_STATUS,
                this.$constant.ALL_STATUS
            ]
        }
    },

    computed: {
        ...mapState(['nationalities']),
        ...mapGetters({
            getCustomerRegisterTypeById: 'customer/getCustomerRegisterTypeById'
        })
    },

    methods: {
        viewBookingDetails (bookingItem) {
            this.$refs.bookingDetailsPanel.open(bookingItem)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
